// @flow

import React, { type Node } from 'react';
import {
  getCountry,
  getCustomerEmail,
  usePendingIncomingPayment,
  type PendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';

export function MailWarning(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <p style={{ textAlign: 'left', marginBottom: '16px', fontWeight: '400' }}>
      <Message incomingPayment={incomingPayment} />
    </p>
  );
}

type MessageProps = {|
  incomingPayment: PendingIncomingPayment,
|};

function Message({ incomingPayment }: MessageProps): Node {
  const country = getCountry(incomingPayment);
  const email = getCustomerEmail(incomingPayment);
  switch (country) {
    case 'bo':
      return (
        <>
          Una copia de su número de recaudación fue enviada a <strong>{email}</strong>,
          sin embargo, ya puede pagar su compra con los siguientes datos:
        </>
      );
    default:
      return (
        <>
          Una cópia ya fue enviada para <strong>{email}</strong>,
          sin embargo, ya puedes pagar tu compra con los seguientes datos:
        </>
      );
  }
}
